export default __webpack_public_path__ + "static/media/session_goal.77c05730.png";